import { CountResponse } from '@interfaces/common.interface';
import {
  CountCustomersRequestParams,
  CreateCustomerRequest,
  Customer,
  GetCustomersRequestParams,
  GetCustomersXlsxQueryParams,
  UpdateCustomerRequest,
} from '@interfaces/customer.interface';

import api from './';

export const {
  useGetCurrentCustomerQuery,
  useUpdateCurrentCustomerMutation,
  useCreateCustomerMutation,
  useGetCustomerByIdQuery,
  useCountCustomersQuery,
  useGetCustomersQuery,
  useLazyGetCustomersXlsxQuery,
} = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentCustomer: builder.query<Customer, void>({
      query: () => ({ url: '/customers/me' }),
      providesTags: ['customer'],
    }),
    getCustomerById: builder.query<Customer, number>({
      query: (id) => ({ url: `/customers/${id}` }),
      providesTags: ['customer'],
    }),
    countCustomers: builder.query<CountResponse, CountCustomersRequestParams>({
      query: (params) => ({
        url: 'customers/count',
        params,
      }),
      providesTags: ['customers'],
    }),
    getCustomers: builder.query<Customer[], GetCustomersRequestParams>({
      query: (params) => ({
        url: 'customers',
        params,
      }),
      providesTags: ['customers'],
    }),
    updateCurrentCustomer: builder.mutation<Customer, UpdateCustomerRequest>({
      query: (body) => ({
        url: '/customers/me',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['customer'],
    }),
    createCustomer: builder.mutation<Customer, CreateCustomerRequest>({
      query: ({ body, recaptchaToken }) => ({
        url: 'customers',
        method: 'POST',
        body,
        headers: {
          'x-grecaptcha': recaptchaToken,
        },
      }),
    }),
    getCustomersXlsx: builder.query<Blob, GetCustomersXlsxQueryParams>({
      query: (params) => ({
        url: 'customers/xlsx',
        params,
        responseHandler: async (response) => await response.blob(),
        cache: 'no-cache',
      }),
    }),
  }),
});
